<template>
  <div class="u-containar-md registerForm">
    <HeadingLv3 text="パスワードを設定してください" setLabelSlot> </HeadingLv3>
    <p>パスワードには以下の制限があります。</p>
    <p>
      半角英数字記号を8文字以上30文字以内で入力してください。<br />※パスワードを忘れた場合は、事務局にお問い合わせいただく必要がありますので、ご注意ください。<br />
      ◆お問い合わせ マイナビRESIDENT運営事務局<br />
      <a href="/contact/input" target="_blank"
        >https://resident.mynavi.jp/contact/input/</a
      >
    </p>

    <form>
      <FormInputField
        id="password"
        type="password"
        name="password"
        :password-switch="true"
        label="パスワード"
        :value="data.password"
        patternLabel="半角英数字記号8～30文字以内"
        placeholder="パスワードを入力してください"
        :error="validations.password.isError"
        :error-message="validations.password.errorMessage"
        @change-message="changeMessage('password', $event)"
        req
      />

      <FormInputField
        id="password_confirmation"
        type="password"
        name="password_confirmation"
        :password-switch="true"
        :value="data.password_confirmation"
        label="パスワード(確認用) "
        patternLabel="半角英数字記号8～30文字以内"
        placeholder="パスワード(確認用)を入力してください"
        :error="validations.password_confirmation.isError"
        :error-message="validations.password_confirmation.errorMessage"
        @change-message="
          checkConfirmField(
            {
              name: 'password_confirmation',
              target: data.password
            },
            $event
          )
        "
        req
      />

      <GoalButtons>
        <Button label="登録確認に進む" :handleClick="goConfirm" primary />
      </GoalButtons>
    </form>
  </div>
</template>

<script lang="ts">
import { onMounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { applyValidation } from '@/utils/validation'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import FormInputField from '@/components/block/FormInputField.vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import Button from '@/components/elements/Button.vue'
import axios from 'axios'

export default {
  components: {
    FormInputField,
    Button,
    GoalButtons,
    HeadingLv3
  },

  props: {
    data: Object
  },

  setup(props: any, context: any) {
    const validations = reactive<any>({
      password: {
        rules: ['password'],
        isError: false,
        errorMessage: ''
      },
      password_confirmation: {
        rules: ['matchPassword'],
        isError: false,
        errorMessage: ''
      }
    })

    const csrf = ref(
      document.querySelector('meta[name="csrf-token"]')!.getAttribute('content')
    )
    const router = useRouter()

    const goConfirm = async () => {
      try {
        await axios.post(`/api/v1/start_use/check_password`, {
          password: props.data.password,
          password_confirmation: props.data.password_confirmation,
          csrf: csrf.value
        })
        router.push('/procedure/confirm')
      } catch (errors) {
        if (errors.response.data) {
          const errorInfo = errors.response.data
          Object.keys(errorInfo).forEach((key) => {
            if (validations[key]) {
              validations[key].isError = true
              validations[key].errorMessage = errorInfo[key].join()
            }
          })
        }
        alert('入力内容に誤りがあるので確認してください')
      }
    }

    const changeMessage = (name: string, value: string) => {
      context.emit('update-profile', name, value)
      const result = applyValidation(validations[name].rules, value)

      validations[name].isError = result.isError
      validations[name].errorMessage = result.message
    }
    const checkConfirmField = (obj: Record<string, string>, value: string) => {
      const rules = validations[obj.name].rules

      const arr: Array<string> = []

      for (let i = 0; i < rules.length; i++) {
        if (rules[i] === 'matchPassword') {
          arr.push('matchPassword:' + obj.target)
        } else {
          arr.push(rules[i])
        }
      }

      const result = applyValidation(arr, value)

      validations[obj.name].isError = result.isError
      validations[obj.name].errorMessage = result.message

      context.emit('update-profile', obj.name, value)
    }

    onMounted(async () => {
      const route = useRoute()
      try {
        const user: any = await axios.get(
          `/api/v1/start_use/user/${route.params.token}`
        )
        context.emit('update-profile', 'email', user.data)
        context.emit('update-profile', 'token', route.params.token)
      } catch (e) {
        alert('不正なトークンです。再度仮登録フォームから設定をお願いします。')
        router.push('/procedure/register')
      }
    })

    return {
      changeMessage,
      validations,
      checkConfirmField,
      goConfirm
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

// h3 {
//   margin-bottom: 1em;
// }
p {
  margin-bottom: 1em;
  &:first-of-type {
    margin-top: 1em;
  }
  &:last-of-type {
    margin-bottom: 2em;
  }
}
a {
  color: var.$color-main-text;
}
</style>
